
import React, { useRef, useEffect, useState } from "react";

import './styles1.css'


/*
 options: [
        { value:'hh4488884.doc', label:'midocuemnto.doc' },
        { value:'jjj33444.jpg', label:'archivo.jpg' },
        { value:'66s666s6s.png', label:'archivo3.png' },
      ],

dissabled:dissabled 
 */
const ListFile = ({ name, options, value, 
                    onChange, onDelete, 
                    disabled, ...props }) => {
    // 
    const [label, setLabel] = useState(value);
    //const defaultChecked = checked ? checked : false;
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    const click_func =(e)=>{
      console.log("click_func")
      //--- a cada click tenemos que hacer que cambie de valor
    
      //------ preparamos para enviar afuera
      e.target.name = name
      e.target.value = 'new_value'
      //console.log(e.target.value)
      onChange(e);
    }
    //--------------------------------
    const click_delete=(item)=>{
      //----borramos un item
      onDelete(item);
    }
    
    const click_down=(item)=>{
      console.log("click_down")
      //----borramos un item
      //onDelete(item);
    }
    //-----------------------------------
    return (
      <div>
      {/*<div className="box2">
        <div className="box2-header">
          <span>
            Archivos
          </span>
        </div>
        <ul className="list">
          {
            options.map( (item, index) => (
            <li key={ index } className="item">
              <div>
              { item.label}
              </div>
              <span className="right-icon " onClick={ click_delete(item) }>
                <i className=" fa fa-trash fa-lg"></i>
              </span>
            </li>
            ))
          }
          
        </ul>
      </div>
      */}
      <table className="tabla_files">
        <thead class="">
          <tr class="font-bold  bg-gray-50">
            <th colSpan={2} class="text-center border-blue-500 " style={{padding: 10 }} >Archivos</th>
          </tr>
        </thead>

        <tbody class="text-gray-700"  style={{backgroundColor: 'white'}}>
          {
            options.map( (item, index) => (
              <tr key={ index } className="">
                <td class="px-4 py-4" style={{ width: '90%' }}>
                  { item.label}
                </td>
                <td class="" style={{ display: 'flex' }}>
                  <span className="right-icon icon1" onClick={()=> click_delete(item) }
                    title="Eliminar">
                    <i className=" fa fa-trash fa-lg" style={{color: '#dc3545'}}></i>
                  </span>
                  &nbsp;
                  <span className="right-icon icon1" onClick={()=> click_down(item) }
                      title="Descargar">
                    <i className=" fa fa-arrow-circle-down fa-lg" style={{color: '#4484f7'}}></i>
                  </span>
                </td>
              </tr>
            ))
          }
          
        </tbody>
      </table>
      </div>
    );
  }
  
  export default ListFile;


  /*<NuCheckbox
      label=""
      name="chk_e1"
      value={this.state.form.chk_e1}
      onChange={ this.handleChangeForm }
    />*/



    /*
    <li>
          Item One
          <span className="badge">2</span>
        </li>
        <li>
          Item Two
          <span className="badge">10</span>
        </li>
        <li>
          Item Three
          <span className="badge">9</span>
        </li>
        <li>
          Item Four
          <span className="badge">0</span>
        </li>
         */